import { Config } from "next-i18n-router/dist/types";

const i18nConfig: Config = {
    locales: ["en", "hr"],
    defaultLocale: "en",
    prefixDefault: true,
};

export default i18nConfig;
